import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import { Formik } from 'formik';
import xss from 'xss';
import * as Yup from 'yup';
import axios from 'axios';
import { ajaxSuccess } from '../../helpers/tagManager';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import Cookies from 'universal-cookie';

import Form from '../Form';
import WrappedField from '../WrappedField';
import Button from '../Button';
import StatementContact from '../StatementContact';

import IconEnvelopeSrc from '../../img/svg/icons/envelope-empty.svg';
import IconTick from '../../img/svg/icons/tick.svg';
import BackgroundSrc from '../../img/svg/newsletter_modal_bg.svg';
import Bars1Src from '../../img/svg/pageHome/bar-1.svg';
import IconClose from '../../img/svg/icons/close.svg';

const propTypes = {
  tagName: PropTypes.string,
  onSuccess: PropTypes.func,
};

const defaultProps = {
  tagName: 'div',
  isPrecise: false,
  variants: [],
  className: '',
};

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(32, 39, 48, 0.5)'
  },
};

const formSchema = Yup.object().shape({
  EMAIL: Yup.string()
    .email('Email must be valid')
    .required('Email is required')
});

const cookies = new Cookies();

class NewsletterPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      hasSubmitSucceeded: false,
      hasSubmitFailed: false,
      isToggledModal: true
    };
  }

  resetStates() {
    this.setState({
      hasSubmitSucceeded: false,
      hasSubmitFailed: false
    });
  }

  sendForm = async data => {
    const email = data['EMAIL'];
    const formAPI = '/.netlify/functions/getresponse';

    this.resetStates();

    await axios({
      method: 'get',
      url: formAPI,
      params: {
        function: 'newsletter',
        idList: this.props.idList,
        email: email,
        tags: JSON.stringify(['VdaSb']) // newsletter_blog_popup
      }
    })
      .then(res => {
        const newState = res.status == 202
          ? { hasSubmitSucceeded: true }
          : { hasSubmitFailed: true };

        if (res.status == 202) {
          trackCustomEvent({
            category: "newsletter",
            action: "submit"
          });

          ajaxSuccess(this.props.idHTML);

          const date = new Date();
          date.setFullYear(date.getFullYear() + 100); // set for 100 years 

          cookies.set(this.props.cookiesName, true, { path: '/', expires: date });

          this.setState({
            ...newState,
          });
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          if (error.response.status == 409) {
            this.setState({
              error: 'This email address is already subscribed'
            });
          } else {
            this.setState({
              error: 'Something went wrong...'
            });
          }
        }
      });
  };

  setToggledModal = (val) => {
    this.setState({ isToggledModal: val });

    var date = new Date();
    date.setDate(date.getDate() + 7); // add a 7 days

    if (!val) {
      cookies.set(this.props.cookiesName, true, { path: '/', expires: date });
    }
  }

  render() {
    // const { title, text } = this.props;
    const { hasSubmitSucceeded, isToggledModal, error } = this.state;
    const btnIsDisabled = hasSubmitSucceeded ? { 'disabled': 'disabled' } : '';

    const initialValues = {
      EMAIL: '',
    };

    return (
      <Modal
        isOpen={isToggledModal}
        onRequestClose={() => this.setToggledModal(false)}
        ariaHideApp={false}
        style={customStyles}
        className="NewsletterPopup Modal"
      >
        <button
          className="NewsletterPopup__btnClose"
          onClick={() => this.setToggledModal(false)}
        >
          <SVG src={IconClose} />
        </button>

        <SVG
          src={Bars1Src}
          className="NewsletterPopup__bar NewsletterPopup__bar--1"
        />

        <SVG
          src={Bars1Src}
          className="NewsletterPopup__bar NewsletterPopup__bar--2"
        />

        <div>
          <div className="NewsletterPopup__background">
            <SVG
              src={BackgroundSrc}
              uniquifyIDs={false}
              className="NewsletterPopup__background-image"
            />
          </div>

          <div className="NewsletterPopup__background">
            <SVG
              src={BackgroundSrc}
              uniquifyIDs={false}
              className="NewsletterPopup__background-image"
            />
          </div>
        </div>

        <h3 className="NewsletterPopup__title" dangerouslySetInnerHTML={{ __html: xss(this.props.title) }}>

        </h3>
        <div className="NewsletterPopup__rows">
          {this.props?.items?.map((e, i) => (
            <div className="NewsletterPopup__row" key={i}>
              <p className="NewsletterPopup__descr" dangerouslySetInnerHTML={{ __html: xss(e.item) }}></p>
            </div>
          ))}
          <div className="NewsletterPopup__row">
            <Formik
              validationSchema={formSchema}
              initialValues={initialValues}
              onSubmit={this.sendForm}
            >
              {({ errors, touched }) => (
                <>
                  <Form
                    className="NewsletterPopup__form"
                  >
                    {!hasSubmitSucceeded ? (
                      <>
                        <WrappedField
                          type="email"
                          name="EMAIL"
                          error={errors.EMAIL}
                          isTouched={touched.EMAIL}
                          placeholder="Type your email"
                          iconSrc={IconEnvelopeSrc}
                        />

                        <Button
                          type="submit"
                          className="NewsletterPopup__submit"
                          variants={['full']}
                          {...btnIsDisabled}
                        >
                          {this.props.btnText}
                        </Button>

                        {error.length >= 1 &&
                          <div
                            className="NewsletterPopup__error"
                            dangerouslySetInnerHTML={{ __html: xss(error) }}
                          />
                        }
                      </>
                    ) : (
                      <div className="NewsletterPopup__success">
                        <div className="NewsletterPopup__success__col">
                          <SVG
                            src={IconTick}
                            className="NewsletterPopup__success__icon"
                          />
                        </div>
                        <div className="NewsletterPopup__success__col">
                          <div className="NewsletterPopup__success__title">
                            {this.props.thanksText}
                          </div>
                          <div className="NewsletterPopup__success__subtitle">
                            {this.props.successText}
                          </div>
                        </div>
                      </div>
                    )}
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </div>

        <div className="NewsletterPopup__statement">
          <StatementContact />
        </div>
      </Modal>
    );
  }
}

NewsletterPopup.propTypes = propTypes;
NewsletterPopup.defaultProps = defaultProps;

export default NewsletterPopup;
